import React from 'react'
import Ipt from 'react-immutable-proptypes'
import { HelpBlock } from 'react-bootstrap'

import Icon from '../Icon'

export default function FormErrors({ errors }) {
  if (!errors || !errors.size) {
    return false
  }

  return (
    <div className="field-errors">
      {errors.map(error => (
        <HelpBlock key={error.get('message')}>
          <Icon name="exclamation-triangle" /> {error.get('message')}
        </HelpBlock>
      ))}
    </div>
  )
}

FormErrors.propTypes = {
  errors: Ipt.set,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Form/FormErrors.jsx